export enum UsersEnum {
  ADMIN       = '0',
  CLIENT      = '1',
  PROVIDER    = '2',
  TECHNICIAN  = '3',
}
